/* Moj račun — uporabniške nastavitve (ime, priimek, e-mail, geslo).
   [PATCH moj-racun v1] */
import React, { useEffect, useState } from 'react';
import { User, Key, Save, Loader2, ShieldCheck } from 'lucide-react'; // [PATCH 2fa v1]
import toast from 'react-hot-toast';
import { api } from '../lib/api';

const inp = 'w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm text-gray-900 dark:text-white focus:outline-none focus:border-blue-400';
const lbl = 'block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1';

export function MojRacunPage() {
  const [nalagam, setNalagam] = useState(true);
  const [ime, setIme] = useState('');
  const [priimek, setPriimek] = useState('');
  const [email, setEmail] = useState('');
  const [vloga, setVloga] = useState('');
  const [shranjujem, setShranjujem] = useState(false);
  const [staro, setStaro] = useState('');
  const [novo, setNovo] = useState('');
  const [novo2, setNovo2] = useState('');
  const [menjam, setMenjam] = useState(false);
  // [PATCH 2fa v1] dvofaktorska prijava
  const [dvofa, setDvofa] = useState(false);
  const [qr2fa, setQr2fa] = useState('');
  const [skrivnost2fa, setSkrivnost2fa] = useState('');
  const [koda2fa, setKoda2fa] = useState('');
  const [geslo2fa, setGeslo2fa] = useState('');
  const [delam2fa, setDelam2fa] = useState(false);

  useEffect(() => {
    api.get('/moj-racun/profil')
      .then((r: any) => {
        setIme(r.data?.first_name || '');
        setPriimek(r.data?.last_name || '');
        setEmail(r.data?.email || '');
        setVloga(r.data?.role || '');
        setDvofa(!!r.data?.totp_enabled); // [PATCH 2fa v1]
      })
      .catch(() => toast.error('Napaka pri nalaganju profila'))
      .finally(() => setNalagam(false));
  }, []);

  const shraniProfil = async () => {
    if (!email.trim()) { toast.error('E-mail je obvezen'); return; }
    setShranjujem(true);
    try {
      const r = await api.put('/moj-racun/profil', { first_name: ime, last_name: priimek, email });
      if (r.data?.email) setEmail(r.data.email);
      toast.success(r.data?.email_spremenjen
        ? 'Shranjeno. Za prijavo odslej uporabljaj novi e-mail.'
        : 'Shranjeno.');
    } catch (e: any) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Napaka pri shranjevanju');
    } finally { setShranjujem(false); }
  };

  const spremeniGeslo = async () => {
    if (!staro || !novo || !novo2) { toast.error('Izpolni vsa tri polja'); return; }
    if (novo !== novo2) { toast.error('Novi gesli se ne ujemata'); return; }
    setMenjam(true);
    try {
      await api.post('/moj-racun/geslo', { staro_geslo: staro, novo_geslo: novo, novo_geslo_2: novo2 });
      toast.success('Geslo spremenjeno.');
      setStaro(''); setNovo(''); setNovo2('');
    } catch (e: any) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Napaka pri spremembi gesla');
    } finally { setMenjam(false); }
  };

  // [PATCH 2fa v1] 2FA handlerji
  const zacni2fa = async () => {
    setDelam2fa(true);
    try {
      const r = await api.post('/moj-racun/2fa/zacni', {});
      setQr2fa(r.data?.qr_png_base64 || '');
      setSkrivnost2fa(r.data?.secret || '');
      setKoda2fa('');
    } catch (e: any) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Napaka pri vklopu 2FA');
    } finally { setDelam2fa(false); }
  };
  const potrdi2fa = async () => {
    if (koda2fa.trim().length < 6) { toast.error('Vpiši 6-mestno kodo'); return; }
    setDelam2fa(true);
    try {
      await api.post('/moj-racun/2fa/potrdi', { koda: koda2fa });
      setDvofa(true); setQr2fa(''); setSkrivnost2fa(''); setKoda2fa('');
      toast.success('2FA vklopljena.');
    } catch (e: any) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Napaka pri potrditvi');
    } finally { setDelam2fa(false); }
  };
  const preklici2fa = () => { setQr2fa(''); setSkrivnost2fa(''); setKoda2fa(''); };
  const izklopi2fa = async () => {
    if (!geslo2fa) { toast.error('Vpiši trenutno geslo'); return; }
    setDelam2fa(true);
    try {
      await api.post('/moj-racun/2fa/izklopi', { geslo: geslo2fa });
      setDvofa(false); setGeslo2fa('');
      toast.success('2FA izklopljena.');
    } catch (e: any) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Napaka pri izklopu');
    } finally { setDelam2fa(false); }
  };

  if (nalagam) {
    return (
      <div className="flex items-center justify-center gap-2 text-gray-400 py-16">
        <Loader2 className="w-5 h-5 animate-spin" /> Nalagam…
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div>
        <h1 className="text-xl font-bold text-gray-900 dark:text-white">Moj račun</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Uporabniške nastavitve{vloga ? ' \u00b7 vloga: ' + (({ racunovodja: 'Računovodja', admin: 'Administrator', stranka: 'Stranka', superadmin: 'Superadmin' } as any)[vloga] || vloga) : ''} {/* [PATCH moj-racun v1a] prikazni label vloge */}
        </p>
      </div>

      <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
        <div className="flex items-center gap-2 mb-4">
          <User className="w-5 h-5 text-blue-500" />
          <h2 className="font-semibold text-gray-900 dark:text-white">Osebni podatki</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className={lbl}>Ime</label>
            <input className={inp} value={ime} onChange={(e) => setIme(e.target.value)} maxLength={100} />
          </div>
          <div>
            <label className={lbl}>Priimek</label>
            <input className={inp} value={priimek} onChange={(e) => setPriimek(e.target.value)} maxLength={100} />
          </div>
          <div className="sm:col-span-2">
            <label className={lbl}>E-mail (uporablja se za prijavo)</label>
            <input className={inp} type="email" value={email} onChange={(e) => setEmail(e.target.value)} maxLength={255} />
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <button onClick={shraniProfil} disabled={shranjujem}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white text-sm font-medium transition">
            {shranjujem ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Shrani
          </button>
        </div>
      </div>

      <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
        <div className="flex items-center gap-2 mb-4">
          <Key className="w-5 h-5 text-blue-500" />
          <h2 className="font-semibold text-gray-900 dark:text-white">Sprememba gesla</h2>
        </div>
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className={lbl}>Staro geslo</label>
            <input className={inp} type="password" value={staro} onChange={(e) => setStaro(e.target.value)} autoComplete="current-password" />
          </div>
          <div>
            <label className={lbl}>Novo geslo (vsaj 8 znakov)</label>
            <input className={inp} type="password" value={novo} onChange={(e) => setNovo(e.target.value)} autoComplete="new-password" />
          </div>
          <div>
            <label className={lbl}>Ponovi novo geslo</label>
            <input className={inp} type="password" value={novo2} onChange={(e) => setNovo2(e.target.value)} autoComplete="new-password" />
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <button onClick={spremeniGeslo} disabled={menjam}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white text-sm font-medium transition">
            {menjam ? <Loader2 className="w-4 h-4 animate-spin" /> : <Key className="w-4 h-4" />} Spremeni geslo
          </button>
        </div>
        <p className="mt-3 text-xs text-gray-400">
          Po spremembi gesla obstoječe prijave ostanejo aktivne; novo geslo velja ob naslednji prijavi.
        </p>
      </div>

      {/* [PATCH 2fa v1] dvofaktorska prijava */}
      <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
        <div className="flex items-center gap-2 mb-4">
          <ShieldCheck className="w-5 h-5 text-blue-500" />
          <h2 className="font-semibold text-gray-900 dark:text-white">Dvofaktorska prijava (2FA)</h2>
          {dvofa && (
            <span className="ml-auto text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300">
              Vklopljena
            </span>
          )}
        </div>

        {!dvofa && !qr2fa && (
          <div>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
              Ob prijavi bo poleg gesla potrebna 6-mestna koda iz aplikacije
              (Google Authenticator, Microsoft Authenticator, Aegis …).
            </p>
            <button onClick={zacni2fa} disabled={delam2fa}
              className="flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white text-sm font-medium transition">
              {delam2fa ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />} Vklopi 2FA
            </button>
          </div>
        )}

        {!dvofa && qr2fa && (
          <div className="space-y-3">
            <p className="text-sm text-gray-500 dark:text-gray-400">1. Skeniraj QR kodo z aplikacijo (ali ročno vpiši ključ):</p>
            <img src={'data:image/png;base64,' + qr2fa} alt="QR za 2FA"
              className="w-44 h-44 rounded-lg border border-gray-200 dark:border-gray-700 bg-white p-1" />
            <div className="text-xs font-mono text-gray-500 dark:text-gray-400 break-all">{skrivnost2fa}</div>
            <p className="text-sm text-gray-500 dark:text-gray-400">2. Vpiši 6-mestno kodo iz aplikacije:</p>
            <input className={inp} inputMode="numeric" maxLength={6} value={koda2fa}
              onChange={(e) => setKoda2fa(e.target.value)} placeholder="123456" />
            <div className="flex justify-end gap-2">
              <button onClick={preklici2fa}
                className="px-4 py-2 rounded-lg border border-gray-200 dark:border-gray-700 text-sm text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition">
                Prekliči
              </button>
              <button onClick={potrdi2fa} disabled={delam2fa}
                className="flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white text-sm font-medium transition">
                {delam2fa ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />} Potrdi in vklopi
              </button>
            </div>
          </div>
        )}

        {dvofa && (
          <div className="space-y-3">
            <p className="text-sm text-gray-500 dark:text-gray-400">Za izklop vpiši trenutno geslo:</p>
            <input className={inp} type="password" value={geslo2fa}
              onChange={(e) => setGeslo2fa(e.target.value)} autoComplete="current-password" />
            <div className="flex justify-end">
              <button onClick={izklopi2fa} disabled={delam2fa}
                className="flex items-center gap-2 px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700 disabled:opacity-60 text-white text-sm font-medium transition">
                {delam2fa ? <Loader2 className="w-4 h-4 animate-spin" /> : <Key className="w-4 h-4" />} Izklopi 2FA
              </button>
            </div>
            <p className="text-xs text-gray-400">Izgubljen telefon? 2FA ti lahko ponastavi administrator.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default MojRacunPage;
